import { heroCards } from '@/mocks/home';

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden bg-background-50 pt-28 md:pt-32">
      <div className="pointer-events-none absolute -right-24 top-24 hidden h-72 w-72 rounded-full bg-primary-50 blur-3xl lg:block" />
      <div className="pointer-events-none absolute -left-20 top-64 hidden h-60 w-60 rounded-full bg-accent-50 blur-3xl lg:block" />

      <div className="relative mx-auto w-full max-w-shell px-4 md:px-8">
        <div className="animate-rise max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-secondary-200 bg-secondary-50 px-3 py-1 font-label text-xs tracking-wide text-secondary-900">
            <i className="ri-focus-3-line text-[14px]" />
            专题合集 · 每日深挖
          </span>
          <h1 className="mt-6 font-heading text-3xl font-bold leading-[1.25] text-foreground-950 md:text-[46px] md:leading-[1.2]">
            独家深挖，把黑料网曝的
            <span className="text-primary-600">猛料与内幕</span>
            一条条摊开来看
          </h1>
          <p className="mt-5 max-w-2xl font-body text-sm leading-relaxed text-foreground-600 md:text-base">
            这里不做快消式的传闻堆叠。我们把散落各处的私密来源、可交叉验证的时间线与事件细节，整理成一条条能顺着读下去的专题合集，
            满足你对真相的<strong className="font-medium text-foreground-900">好奇与求证</strong>。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 md:mt-16">
          {heroCards.map((card, index) => (
            <article
              key={card.title}
              className="reveal group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors duration-300 hover:border-primary-300"
            >
              <div className="relative h-48 w-full overflow-hidden md:h-52">
                <img
                  src={card.image}
                  alt={card.title}
                  title={`${card.title} - 黑料网曝`}
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.04]"
                />
                <span className="absolute left-3 top-3 rounded-md bg-background-50/92 px-2.5 py-1 font-label text-[11px] font-medium text-primary-700 backdrop-blur">
                  {card.tag}
                </span>
                <span className="absolute right-3 top-3 flex h-7 w-7 items-center justify-center rounded-md bg-foreground-950/70 font-label text-[11px] text-background-50 backdrop-blur">
                  {String(index + 1).padStart(2, '0')}
                </span>
              </div>

              <div className="flex flex-1 flex-col p-5">
                <h2 className="font-heading text-[17px] font-semibold leading-snug text-foreground-950">
                  {card.title}
                </h2>
                <p className="mt-3 flex-1 font-body text-[13.5px] leading-relaxed text-foreground-600">
                  {card.summary}
                </p>
                <div className="mt-5 flex items-center justify-between border-t border-background-200 pt-4">
                  <span className="font-label text-[11.5px] text-foreground-500">{card.meta}</span>
                  <span className="flex items-center gap-1 font-label text-[12px] text-primary-600">
                    进入专题
                    <i className="ri-arrow-right-line text-[15px]" />
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}